import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { coordinationQueryKeys } from '@/modules/coordination/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface RejectCandidateJobParams {
  jobId: string;
  candidateId: string;
  /** Edited rejection message; omit to let the API send its default one. */
  message?: string | null;
}

export const useRejectCandidateJobMutation = () => {
  return useMutation({
    mutationFn: ({ jobId, candidateId, message }: RejectCandidateJobParams) =>
      fetchClient.POST('/jobs/{jobId}/candidates/{candidateId}/reject', {
        params: {
          path: {
            jobId,
            candidateId,
          },
        },
        body: message ? { message } : undefined,
      }),
    onSettled: (_data, _error, variables) => {
      const { jobId, candidateId } = variables;
      const detailQueryKey = candidateJobQueryKeys.detail(jobId, candidateId);
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
      invalidateQuery(detailQueryKey)();
      invalidateQuery(coordinationQueryKeys.processes(jobId))();
    },
  });
};
